import { Grid } from "@mui/material";
import { SummaryDto } from "../../app/models/summary/summaryDto";
import { useAppSelector } from "../../app/store/configureStore";
import React, { } from "react";
import AppInformationText from "../../app/components/AppInformationText";
import cpdCategoriesFormModel from "../pcsCpd/common/cpdCategoriesFormModel";
import { GetSummaryColorCode } from "../../app/utils/util";

interface Props {
    sixYearSummaryData: SummaryDto[][] | null;
    isYearPartialyCompleted: boolean;
    totalOfSummary: number[];
}

export default function SummaryForm({ sixYearSummaryData, isYearPartialyCompleted, totalOfSummary }: Props) {
    const {
        formField: {
            AccreditedCeActivity,
            ProfessionalDevelopmentPlan,
            PracticeReview,
            WorkbasedLearning,
            Total,
            OnTarget
        }
    } = cpdCategoriesFormModel;

    const { summaryTitles } = useAppSelector(state => state.pcs);
    return <Grid container>
        <Grid display={{ xs: 'block' }} size={{ xs: 4, sm: 1 }} sx={{ textAlign: 'center' }}>
            <b>{summaryTitles === null ? '' : summaryTitles[0]}</b>
        </Grid>

        <Grid display={{ xs: 'none', sm: 'block' }} size={{ sm: 1 }} sx={{ textAlign: 'center' }}>
            <b>{summaryTitles === null ? '' : summaryTitles[1]}</b>
        </Grid>
        <Grid display={{ xs: 'none', sm: 'block' }} size={{ sm: 1.5 }} sx={{ textAlign: 'center' }}>
            <b>{summaryTitles === null ? '' : summaryTitles[3]}</b>
            <br />
            <AppInformationText information_text={AccreditedCeActivity.informationText} placement="bottom" />
        </Grid>
        <Grid display={{ xs: 'none', sm: 'block' }} size={{ sm: 1.5 }} sx={{ textAlign: 'center' }}>
            <b>{summaryTitles === null ? '' : summaryTitles[4]}</b>
            <br />
            <AppInformationText information_text={ProfessionalDevelopmentPlan.informationText} placement="bottom" />
        </Grid>
        <Grid display={{ xs: 'none', sm: 'block' }} size={{ sm: 1.5 }} sx={{ textAlign: 'center' }}>
            <b>{summaryTitles === null ? '' : summaryTitles[5]}</b>
            <br />
            <AppInformationText information_text={PracticeReview.informationText} placement="bottom" />
        </Grid>
        <Grid display={{ xs: 'none', sm: 'block' }} size={{ sm: 1.5 }} sx={{ textAlign: 'center' }}>
            <b>{summaryTitles === null ? '' : summaryTitles[6]}</b>
            <br />
            <AppInformationText information_text={WorkbasedLearning.informationText} placement="bottom" />
        </Grid>

        <Grid display={{ xs: 'none', sm: 'block' }} size={{ sm: 1 }} sx={{ textAlign: 'center' }}>
            <b>{Total.label}</b>
            <br />
            <AppInformationText information_text={Total.informationText} placement="bottom" />
        </Grid>

        <Grid size={{ xs: 2 }} display={{ xs: 'block', sm: 'none' }}></Grid>

        <Grid display={{ xs: 'block' }} size={{ xs: 6, sm: 1.5 }} sx={{ textAlign: 'center' }}>
            <b>{summaryTitles === null ? '' : summaryTitles[7]}</b>
            <br />
            <AppInformationText information_text={OnTarget.informationText} placement="bottom" />
        </Grid>

        <Grid display={{ xs: 'none', sm: 'block' }} size={{ sm: 1.5 }} sx={{ textAlign: 'center' }}>
            <b>{summaryTitles === null ? '' : summaryTitles[8]}</b>
        </Grid>

        {sixYearSummaryData?.map((item: SummaryDto[], index: number) => (
            <React.Fragment key={index}>

                <Grid size={{ xs: 4, sm: 1 }}>
                    <Grid display={{ xs: 'block' }} sx={{ textAlign: 'center', paddingTop: '16px' }}>
                        {item[0].text}
                        {item[2].text.toLowerCase() === "true" ? "*" : ""}
                    </Grid>
                </Grid>

                <Grid display={{ xs: 'none', sm: 'block' }} size={{ sm: 1 }}>
                    <Grid sx={{ textAlign: 'center', paddingTop: '16px' }}>{item[1].text}</Grid>
                </Grid>

                <Grid display={{ xs: 'none', sm: 'block' }} size={{ sm: 1.5 }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[3].status.toUpperCase()),
                        textAlign: 'center', padding: 1
                    }}><b>{item[3].text.split('(')[0]}</b>({item[3].text.split('(')[1]}</Grid>
                </Grid>

                <Grid display={{ xs: 'none', sm: 'block' }} size={{ sm: 1.5 }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[4].status.toUpperCase()),
                        textAlign: 'center', padding: 1
                    }}><b>{item[4].text.split('(')[0]}</b>({item[4].text.split('(')[1]}</Grid>
                </Grid>

                <Grid display={{ xs: 'none', sm: 'block' }} size={{ sm: 1.5 }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[5].status.toUpperCase()),
                        textAlign: 'center', padding: 1
                    }}><b>{item[5].text.split('(')[0]}</b>({item[5].text.split('(')[1]}</Grid>
                </Grid>

                <Grid size={{ sm: 1.5 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[6].status.toUpperCase()),
                        textAlign: 'center', padding: 1
                    }}><b>{item[6].text.split('(')[0]}</b>({item[6].text.split('(')[1]}</Grid>
                </Grid>

                <Grid size={{ sm: 1 }} display={{ xs: 'none', sm: 'block' }} sx={{ padding: 1 }}>
                    <Grid sx={{ textAlign: 'center', padding: 1 }}>
                        <b>{totalOfSummary[index]}</b>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 2 }} display={{ xs: 'block', sm: 'none' }}></Grid>

                <Grid size={{ xs: 6, sm: 1.5 }} display={{ xs: 'block' }} sx={{ padding: 1 }}>
                    <Grid sx={{
                        backgroundColor: GetSummaryColorCode(item[7].status.toUpperCase()),
                        textAlign: 'center', padding: 1
                    }}>{item[7].text}</Grid>
                </Grid>

                <Grid size={{ sm: 1.5 }} display={{ xs: 'none', sm: 'block' }}>
                    <Grid sx={{ textAlign: 'center', paddingTop: '16px' }}>{item[8].text}</Grid>
                </Grid>
            </React.Fragment>
        ))}

        {sixYearSummaryData?.length === 0 &&
            <Grid size={{ xs: 12 }} sx={{ textAlign: 'center', padding: 5 }}>No records found.</Grid>
        }

        {isYearPartialyCompleted === true &&
            <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>*Partial Year Completed.</Grid>
        }

        <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
            Note: CPD Category requirements are displayed in brackets.
        </Grid>
    </Grid>
}